import { useEffect, useState, useRef } from 'react';
import { isEqual } from 'lodash';
import usePrevious from './usePrevious';


export default function useDebounce(value, delay = 400) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const previousValue = usePrevious(value);
  const ref = useRef();
  useEffect(
    () => {
      if (isEqual(value, previousValue)) {
        return;
      }

      if (ref.current) {
        clearTimeout(ref.current);
      }

      ref.current = setTimeout(() => {
        setDebouncedValue(value);
        ref.current = null;
      }, delay);
    },

    [value, previousValue, delay],
  );

  return debouncedValue;
}
